import { getUserConfiguration } from 'owa-session-store';

export default function getBlockContentFromUnknownSenders() {
    const userConfiguration = getUserConfiguration();
    return userConfiguration.SafetyUserOptions
        ? userConfiguration.SafetyUserOptions.BlockContentFromUnknownSenders
        : false;
}
